import rambleAppIconWordmark from "./ramble-app-icon-wordmark.svg?url"

export default {
  src: rambleAppIconWordmark,
  width: 621,
  height: 146,
}
